import { useRef } from 'react'
import { useToast } from '../../hooks/toast'
import { Background, ModalWrapper, Button } from './styles'
import { useMutation } from 'react-query'
import { deleteAddress } from '../../hooks/address/useAddresses'
import { queryClient } from '../../services/queryClient'

const DeleteModal = ({ showModal, setShowModal, setCurrent, cardId }) => {
  const modalRef = useRef()
  const { addToast }: any = useToast()

  const { mutateAsync, error } = useMutation(deleteAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries('enderecos')

      addToast({
        type: 'success',
        title: 'Endereço excluído'
      })

      setShowModal(false)
      setCurrent(3)
    },
    onError: () => {
      addToast({
        type: 'error',
        title: 'Erro ao excluir endereço',
        description: `${error}`
      })

      setShowModal(false)
      setCurrent(3)
    }
  })

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false)
    }
  }

  const handleMockDeleteCard = async () => {
    mutateAsync(cardId)
  }

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal}>
          <ModalWrapper>
            <div className="title">
              <h2 className="modal-title">Remover Endereço</h2>
            </div>
            <p className="modal-description">Deseja remover este endereço?</p>
            <div className="button-container">
              <Button onClick={handleMockDeleteCard}>Remover</Button>
              <Button
                className="button-outline"
                onClick={() => setShowModal((prev) => !prev)}
              >
                Cancelar
              </Button>
            </div>
          </ModalWrapper>
        </Background>
      ) : null}
    </>
  )
}

export default DeleteModal
